import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Shield, Zap, Award, Clock, Lock, CreditCard } from 'lucide-react';
import { useCountUp } from '../hooks/useCountUp';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../hooks/useMetaPixel';
export default function PricingSection() {
  const {
    count: buyersCount,
    ref: buyersRef
  } = useCountUp(2847, 3000, true);
  const [liveBuyers, setLiveBuyers] = useState(3);
  const [scarcityCount, setScarcityCount] = useState(23);
  useEffect(() => {
    const interval = setInterval(() => {
      setLiveBuyers(prev => Math.max(2, Math.min(8, prev + (Math.random() > 0.5 ? 1 : -1))));
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() > 0.7 && scarcityCount > 5) {
        setScarcityCount(prev => prev - 1);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [scarcityCount]);
  return <Section id="comprar" className="bg-brand-cream py-20 relative overflow-hidden" data-id="element-277">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-brand-purple/5 blur-[100px] rounded-full pointer-events-none" data-id="element-278" />

      <div className="max-w-lg mx-auto text-center relative z-10" data-id="element-279">
        <div className="mb-8" data-id="element-280">
          <span className="text-brand-purple text-xs font-bold tracking-[0.2em] uppercase block mb-2" data-id="element-281">
            Acceso Instantáneo
          </span>
          <h2 className="font-heading text-4xl md:text-5xl text-slate-900 uppercase tracking-wide" data-id="element-282">
            Sistema CERO DECISIONES
          </h2>
        </div>

        {/* Offer Box */}
        <div className="bg-gradient-to-b from-slate-900 to-brand-dark rounded-2xl border border-brand-purple/30 p-8 shadow-2xl relative overflow-hidden mb-8 group hover:border-brand-purple/50 transition-colors duration-500" data-id="element-283">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-brand-purple/20 blur-3xl rounded-full pointer-events-none" data-id="element-284" />

          <div className="relative z-10" data-id="element-285">
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} className="text-gray-500 text-lg mb-1 font-medium relative inline-block" data-id="element-286">
              <span className="strikethrough-animate active" data-id="element-287">USD $26.00</span>
            </motion.div>

            <div className="text-5xl sm:text-6xl font-bold text-white mb-4 tracking-tight" data-id="element-288">
              USD $6.39
            </div>

            <div className="inline-block bg-red-600 text-white font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-6 shadow-lg shadow-red-600/20 relative overflow-hidden" data-id="element-289">
              <div className="absolute inset-0 animate-shimmer" data-id="element-290" />
              <span className="relative z-10" data-id="element-291">AHORRAS 75% — SOLO HOY</span>
            </div>

            <div className="flex items-center justify-center gap-2 mb-6 bg-white/10 py-1 px-3 rounded-full w-fit mx-auto" data-id="element-292">
              <span className="relative flex h-2 w-2" data-id="element-293">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-294"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-295"></span>
              </span>
              <span className="text-xs text-gray-300" data-id="element-296">
                Comprando ahora:{' '}
                <span className="font-bold text-white" data-id="element-297">{liveBuyers}</span>{' '}
                personas
              </span>
            </div>

            <div className="border-t border-white/10 pt-6 flex flex-wrap justify-center gap-4 sm:gap-6" data-id="element-298">
              <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-299">
                <Shield size={16} className="text-brand-purple" data-id="element-300" />
                <span data-id="element-301">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-302">
                <Zap size={16} className="text-brand-amber" data-id="element-303" />
                <span data-id="element-304">Entrega Inmediata</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-305">
                <Clock size={16} className="text-brand-purple" data-id="element-306" />
                <span data-id="element-307">Acceso de por vida</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4" data-id="element-308">
          <Button variant="primary" size="xl" pulse={true} fullWidth={true} className="text-xl sm:text-2xl py-7 shadow-[0_0_40px_rgba(22,163,74,0.3)] hover:shadow-[0_0_60px_rgba(22,163,74,0.5)] transition-shadow duration-300" onClick={() => {
          trackAddToCart();
          window.open('https://oriammarketing.com/cart/45514687054022:1', '_blank');
        }} data-id="element-309">
            QUIERO DEJAR DE SUFRIR A LAS 6PM
          </Button>
        </div>

        <div className="flex flex-col items-center gap-1 mb-10" data-id="element-310">
          <p className="text-red-600 text-sm font-bold animate-pulse" data-id="element-311">
            Solo quedan {scarcityCount} copias a precio de lanzamiento
          </p>
          <p className="text-slate-400 text-xs" data-id="element-312">
            ✓ Descarga inmediata · ✓ Garantía 7 días · ✓ 0 riesgo
          </p>
        </div>

        {/* Guarantee - Compact */}
        <div className="flex items-center justify-center gap-2 mb-4 bg-brand-cream-dark rounded-full px-4 py-2 border border-brand-brown/15" data-id="element-313">
          <Award className="text-brand-brown w-4 h-4 flex-shrink-0" data-id="element-314" />
          <p className="text-slate-600 text-xs" data-id="element-315">
            <span className="font-bold text-slate-800" data-id="element-316">Garantía 7 días</span> —
            Si no te funciona, te devolvemos el 100%.
          </p>
        </div>

        {/* Secure Payment Banner */}
        <div className="bg-white rounded-xl border border-slate-200 p-4 mb-6 shadow-sm" data-id="element-317">
          <div className="flex items-center justify-center gap-1.5 mb-3" data-id="element-318">
            <Lock size={14} className="text-brand-purple" data-id="element-319" />
            <span className="text-xs font-bold text-slate-700 uppercase tracking-wider" data-id="element-320">
              Pago 100% Seguro
            </span>
          </div>
          <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-321">
            {/* Visa */}
            <div className="bg-slate-50 rounded-md px-3 py-1.5 border border-slate-100" data-id="element-322">
              <svg viewBox="0 0 48 16" className="h-5 w-auto" fill="none" data-id="element-323">
                <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="14" fill="#1A1F71" data-id="element-324">
                  VISA
                </text>
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-slate-50 rounded-md px-3 py-1.5 border border-slate-100 flex items-center gap-1" data-id="element-325">
              <svg viewBox="0 0 32 20" className="h-5 w-auto" data-id="element-326">
                <circle cx="10" cy="10" r="8" fill="#EB001B" data-id="element-327" />
                <circle cx="22" cy="10" r="8" fill="#F79E1B" data-id="element-328" />
                <path d="M16 3.5a8 8 0 0 1 0 13 8 8 0 0 1 0-13z" fill="#FF5F00" data-id="element-329" />
              </svg>
            </div>
            {/* PayPal */}
            <div className="bg-slate-50 rounded-md px-3 py-1.5 border border-slate-100" data-id="element-330">
              <svg viewBox="0 0 60 16" className="h-5 w-auto" fill="none" data-id="element-331">
                <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="11" fill="#003087" data-id="element-332">
                  Pay
                </text>
                <text x="22" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="11" fill="#009CDE" data-id="element-333">
                  Pal
                </text>
              </svg>
            </div>
            {/* Amex */}
            <div className="bg-slate-50 rounded-md px-3 py-1.5 border border-slate-100" data-id="element-334">
              <svg viewBox="0 0 40 16" className="h-5 w-auto" fill="none" data-id="element-335">
                <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="9" fill="#006FCF" data-id="element-336">
                  AMEX
                </text>
              </svg>
            </div>
            {/* Generic card */}
            <div className="bg-slate-50 rounded-md px-3 py-1.5 border border-slate-100 flex items-center gap-1" data-id="element-337">
              <CreditCard size={14} className="text-slate-400" data-id="element-338" />
              <span className="text-[10px] text-slate-400 font-medium" data-id="element-339">
                Débito
              </span>
            </div>
          </div>
          <p className="text-[10px] text-slate-400 text-center mt-2" data-id="element-340">
            Tus datos están protegidos con encriptación SSL de 256 bits
          </p>
        </div>

        <div className="text-center" ref={buyersRef} data-id="element-341">
          <p className="text-sm text-slate-400 flex items-center justify-center gap-2" data-id="element-342">
            <Zap size={14} className="text-brand-amber" data-id="element-343" />
            <span className="font-bold text-slate-600" data-id="element-344">{buyersCount}</span>{' '}
            personas ya transformaron sus semanas
          </p>
        </div>
      </div>
    </Section>;
}